/**
 * @module Home - Section - Carousel P72 Lite
 * @description
 */
import Carousel from '@/blocks/Carousel';
import styles from './style.module.css';
import Tooltip from '@/blocks/Tooltip';
import state from '@/js/config/state';

/**
* @function Component
* @description
*/
const Component = () => (
  <>
    <Carousel
      slides={ [
        {
          image: {
            url: '/sections/carousel/man-gaming-in-room-desktop.jpg',
            blurUrl: '/sections/carousel/man-gaming-in-room-desktop.jpg',
            alt: 'man using VR'
          },
          headline: <><span className={ styles.component__headingEmphasis }>Uncable Yourself</span> Get&nbsp;Fiber Internet</>,
          content: 'Supercharge your home internet with our 100% fiber-optic network. Get faster speed, better gaming, uncapped data and more.'
        },
        {
          image: {
            url: '/sections/carousel/man-on-laptop-with-moving-boxes.jpg',
            blurUrl: '/sections/carousel/man-on-laptop-with-moving-boxes.jpg',
            alt: 'man using laptop on floor around moving boxes',
            width: 1110,
            height: 500
          },
          headline: 'Faster speed',
          content: <>Frontier Fiber 5 Gig internet is blazing fast with uploads up to 16x faster than cable, and we’re the first and only large network provider to offer 5 Gig service across our fiber network.<span data-legal="125x-faster-than-cable" /><Tooltip disclosure="5gig-network" placement="top" /></>
        },
        {
          image: {
            url: state.is_mobile ? '/sections/carousel/woman-on-couch-square.jpg' : '/sections/carousel/woman-enjoying-laptop-on-couch.jpg',
            blurUrl: '/sections/carousel/woman-enjoying-laptop-on-couch.jpg',
            alt: 'woman enjoying laptop on couch'
          },
          headline: <>Uncapped data</>,
          content: <>Paying more to use more? That’s not our style. With no data caps or overage charges, your usage can be as unlimited as the internet itself.<Tooltip disclosure="data-caps" placement="top" /></>
        },
        {
          image: {
            url: '/sections/carousel/woman-using-phone-with-headphones.jpg',
            blurUrl: '/sections/carousel/woman-using-phone-with-headphones.jpg',
            alt: 'woman using phone with headphones'
          },
          headline: 'Speed equality',
          content: 'Unlike cable, fiber offers symmetrical speeds. Which means you can upload data just as blazingly fast as you can download it.'
        }
      ] }
    />
  </>
);

export default Component;
